export default function fallbackCatch(dataList: any[]) {
    return dataList.filter((d) => d === undefined).length > 0
}
